import Account from './Account.page';

export default Account;